import { Flags } from "../../common/providers";

export default [
	{
		name: "navigation:common.opportunities",
		to: "/opportunity",
		flag: Flags.OPPORTUNITY,
		allowedEnvironments: ["prod", "dev", "qa"],
	},
	{
		name: "navigation:common.projects",
		to: "/",
		allowedEnvironments: ["prod", "dev", "qa"],
	},
	{
		name: "navigation:common.espace",
		to: "/",
		allowedEnvironments: ["veolia"],
	},
	{
		name: "navigation:common.portfolio-search",
		to: "/portfolio/search-multiple",
		allowedEnvironments: ["veolia"],
	},
	{
		name: "navigation:common.templates",
		subItems: [
			{
				name: "navigation:common.templates.search-templates",
				to: "/search-templates/search-templates",
				flag: Flags.SEARCHTEMPLATE,
			},
			{
				name: "navigation:common.templates.category-templates",
				to: "/category-template",
				flag: Flags.CATEGORYTEMPLATE,
			},
		],
		allowedEnvironments: ["prod", "dev", "qa"],
	},
];
